import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Logo from "../assets/characters/Bharatparikhsa.png";

export default function MobileTopBar({ userName, onLogout }) {
  const initial = userName ? userName[0].toUpperCase() : null;

  const [showBar, setShowBar] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  // 🔼🔽 scroll hide / show
  useEffect(() => {
    const handleScroll = () => {
      const current = window.scrollY;

      if (current > lastScrollY && current > 60) {
        setShowBar(false);
      } else {
        setShowBar(true);
      }

      setLastScrollY(current);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <div
      className={`md:hidden fixed top-0 left-0 right-0 z-50 bg-white shadow-sm
      transition-transform duration-300
      ${showBar ? "translate-y-0" : "-translate-y-full"}`}
    >
      <div className="flex items-center justify-between px-4 h-16 relative">

        {/* LEFT: Logo + Name */}
        <Link to="/" className="flex items-center gap-2">
          <img src={Logo} alt="Logo" className="h-7 w-auto" />
          <span className="font-semibold text-[#8B5A2B]">
            Bharatparikhsa
          </span>
        </Link>

        {/* RIGHT: Avatar / Icon */}
        <div className="relative">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="w-9 h-9 rounded-full flex items-center justify-center
                       bg-[#8B5A2B] text-white font-bold"
          >
            {userName ? (
              initial
            ) : (
              <span className="text-xl">👤</span>
            )}
          </button>

          {/* DROPDOWN */}
          {menuOpen && (
            <div
              className="absolute right-0 mt-2 w-44 bg-white rounded-xl
                         shadow-lg border border-[#E6D8C3] overflow-hidden"
            >
              {userName ? (
                <>
                  <Link
                    to="/activity"
                    className="block px-4 py-3 text-sm
                               text-[#3A2A1A] hover:bg-[#F4EBDD]"
                    onClick={() => setMenuOpen(false)}
                  >
                    My Activity
                  </Link>

                  <button
                    onClick={() => {
                      setMenuOpen(false);
                      onLogout && onLogout();
                    }}
                    className="w-full text-left px-4 py-3 text-sm
                               text-red-600 hover:bg-red-50"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="block px-4 py-3 text-sm
                               text-[#3A2A1A] hover:bg-[#F4EBDD]"
                    onClick={() => setMenuOpen(false)}
                  >
                    Login
                  </Link>

                  <Link
                    to="/signup"
                    className="block px-4 py-3 text-sm
                               text-[#3A2A1A] hover:bg-[#F4EBDD]"
                    onClick={() => setMenuOpen(false)}
                  >
                    Sign Up
                  </Link>
                </>
              )}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
